// ONE rule (Fab 2026-10-21): a prompt an agent holds is drawn only in the queue bar, never in a
// timeline too. `queued` is a stream entry's own flag; `heldIds` names held prompts by id (a DM row).
// A failed or unconfirmed one is never held: it is a bubble with its Retry (a message is never invisible).
export function isHeldPrompt(
  p: { queued?: boolean; promptId?: string | null; status?: string },
  heldIds?: ReadonlySet<string>,
): boolean {
  if (p.status === "failed" || p.status === "unknown") return false;
  return p.queued === true || (!!p.promptId && !!heldIds?.has(p.promptId));
}

// Providers whose running turn takes a person's send mid-turn (mirrors the server's JOINS_BY_DEFAULT
// in join-on-arrival.ts; held-prompt.source.test.ts keeps the two equal).
export const JOINS_RUNNING_TURN: ReadonlySet<string> = new Set(["claude"]);
